var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { isAccountTag, isHalfYearTag, isMonthTag, isQuarterTag, isVersionTag, isYearTag, } from '@data/tag/types';
function createTagIds(listItem) {
    var tagIds = [listItem.accountTag.id, listItem.yearTag.id, listItem.monthTag.id];
    if (listItem.dimensionTagIds) {
        tagIds.push.apply(tagIds, __spreadArray([], __read(listItem.dimensionTagIds), false));
    }
    if (listItem.quarterTag) {
        tagIds.push(listItem.quarterTag.id);
    }
    if (listItem.halfYearTag) {
        tagIds.push(listItem.halfYearTag.id);
    }
    if (listItem.versionTag) {
        tagIds.push(listItem.versionTag.id);
    }
    return tagIds;
}
export function isNewListItem(newCell) {
    return hasNecesaryTags(newCell);
}
export function hasNecesaryTags(listItem) {
    return !!(listItem === null || listItem === void 0 ? void 0 : listItem.monthTag) && !!(listItem === null || listItem === void 0 ? void 0 : listItem.yearTag) && !!(listItem === null || listItem === void 0 ? void 0 : listItem.accountTag);
}
export function removeDimensionTagId(command) {
    var listItem = command.listItem, dimensionTagId = command.dimensionTagId;
    listItem.dimensionTagIds = listItem.dimensionTagIds.filter(function (id) { return id !== dimensionTagId; });
}
export function addDimensionTagId(command) {
    var listItem = command.listItem, dimensionTagId = command.dimensionTagId;
    listItem.dimensionTagIds = __spreadArray(__spreadArray([], __read(listItem.dimensionTagIds), false), [dimensionTagId], false);
}
export function isExistingListItem(item) {
    return 'id' in item;
}
export function newListItemToCreateCellRequest(newListItem) {
    var tagIds = createTagIds(newListItem);
    var cellReq = {
        date: newListItem.date,
        value: newListItem.value,
        status: newListItem.status,
        jsonData: newListItem.jsonData,
        uniqueId: newListItem.uniqueId,
        description: newListItem.description,
        importJobId: newListItem.importJobId,
        tagIds: tagIds,
    };
    return cellReq;
}
export function listItemToCellRepersentation(listItem) {
    var tagIds = createTagIds(listItem);
    var cellRep = {
        id: listItem.id,
        date: listItem.date,
        value: listItem.value,
        status: listItem.status,
        jsonData: listItem.jsonData,
        uniqueId: listItem.uniqueId,
        description: listItem.description,
        importJobId: listItem.importJobId,
        accountTagId: listItem.accountTagId,
        tagIds: tagIds,
        readonly: false,
    };
    return cellRep;
}
export function cellRepresentationToListItem(cellRep, tagMap) {
    var e_1, _a;
    var _b, _c, _d;
    var versionTag;
    var monthTag;
    var quarterTag;
    var halfYearTag;
    var yearTag;
    var accountTag;
    try {
        for (var _e = __values(cellRep.tagIds), _f = _e.next(); !_f.done; _f = _e.next()) {
            var tagId = _f.value;
            if (versionTag && monthTag && quarterTag && halfYearTag && accountTag) {
                break;
            }
            var tag = tagMap[tagId];
            if (!versionTag && tag && isVersionTag(tag)) {
                versionTag = tag;
            }
            if (!monthTag && tag && isMonthTag(tag)) {
                monthTag = tag;
            }
            if (!quarterTag && tag && isQuarterTag(tag)) {
                quarterTag = tag;
            }
            if (!halfYearTag && tag && isHalfYearTag(tag)) {
                halfYearTag = tag;
            }
            if (!yearTag && tag && isYearTag(tag)) {
                yearTag = tag;
            }
            if (!accountTag && tag && isAccountTag(tag)) {
                accountTag = tag;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var listItem = {
        id: cellRep.id,
        date: (_b = cellRep.date) !== null && _b !== void 0 ? _b : undefined,
        value: cellRep.value,
        status: cellRep.status,
        uniqueId: cellRep.uniqueId,
        jsonData: cellRep.jsonData,
        importJobId: cellRep.importJobId,
        description: (_c = cellRep.description) !== null && _c !== void 0 ? _c : '',
        dimensionTagIds: (_d = cellRep.tagIds.filter(function (id) {
            return id !== (versionTag === null || versionTag === void 0 ? void 0 : versionTag.id) &&
                id !== (yearTag === null || yearTag === void 0 ? void 0 : yearTag.id) &&
                id !== (monthTag === null || monthTag === void 0 ? void 0 : monthTag.id) &&
                id !== (quarterTag === null || quarterTag === void 0 ? void 0 : quarterTag.id) &&
                id !== (halfYearTag === null || halfYearTag === void 0 ? void 0 : halfYearTag.id) &&
                id !== (accountTag === null || accountTag === void 0 ? void 0 : accountTag.id);
        })) !== null && _d !== void 0 ? _d : [],
        versionTag: versionTag,
        monthTag: monthTag,
        quarterTag: quarterTag,
        halfYearTag: halfYearTag,
        accountTag: accountTag,
        yearTag: yearTag,
        readonly: cellRep.readonly,
    };
    if (!hasNecesaryTags(listItem)) {
        throw new Error("Bad cell representation: \n".concat(cellRep));
    }
    return listItem;
}
export function getAccountTagFormat(cell, tagByIdMap) {
    var _a;
    var accTagId = cell.tagIds.find(function (id) { return isAccountTag(tagByIdMap === null || tagByIdMap === void 0 ? void 0 : tagByIdMap[id]); });
    var accTag = accTagId ? tagByIdMap === null || tagByIdMap === void 0 ? void 0 : tagByIdMap[accTagId] : undefined;
    return (_a = accTag === null || accTag === void 0 ? void 0 : accTag.numberFormat) === null || _a === void 0 ? void 0 : _a.format;
}
